import Image from 'next/image';
import cx from 'classnames';
import {GradientContainer} from 'pages/layouts/Claim';

const BlogHeader = ({
  title,
  subTitle,
  image,
  children,
}: {
  title: string;
  subTitle?: string | React.ReactNode;
  image?: string;
  children?: React.ReactNode;
}) => {
  return (
    <GradientContainer
      style={{minHeight: '70vh'}}
      className={cx('lg:!pt-[150px]', {'!pt-0': !!image})}
    >
      <div className="relative w-full">
        <div
          className={cx('inset-0 mb-4 flex w-full', {
            'flex-col lg:flex-row lg:px-8': !!image,
            'justify-center': !image,
          })}
        >
          <div
            className={cx(
              'relative flex w-full items-center justify-center break-words p-8 text-center lg:mt-0 lg:w-auto lg:p-0',
              {
                'mt-36 lg:w-2/4 lg:text-left': !!image,
              }
            )}
          >
            <div className="">
              <div className={cx('mx-auto', 'text-white', {container: !image})}>
                <h1 className="text-5xl leading-tight drop-shadow-lg">{title}</h1>

                {subTitle && (
                  <>
                    <div
                      className={cx(
                        'whitespace-pre-line text-lg leading-normal drop-shadow-md lg:max-w-[70%]',
                        !image && 'mx-auto'
                      )}
                    >
                      {subTitle}
                    </div>
                    {children && <div>{children}</div>}
                  </>
                )}
              </div>
            </div>
          </div>
          {image ? (
            <>
              <div className="align-center relative flex w-full justify-center lg:w-2/4">
                <div className="p-8 lg:p-0 lg:px-8">
                  <Image
                    src={image.includes('sanity') ? image : image.replace('//', '/')}
                    alt={title}
                    height={500}
                    width={500}
                    objectFit="contain"
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </GradientContainer>
  );
};

export default BlogHeader;
